export default __webpack_public_path__ + "static/media/character-yoshishige.8f703517.png";